import React, { useContext, useEffect } from 'react'
import { AppStateContext } from '../AppStateContext'
import { FaPrint, FaTimes } from 'react-icons/fa'

import PanelHeader from '../../../elem/panel/PanelHeader'
import { DataContext } from './DataContext'
import { PanelStyleContext } from '../../../elem/panel/PanelStyleContext'
import ExpandButton from '../../../elem/list/ExpandButton'

export default ({ setIsDetailMenuExpanded }) => {
    const { updateDetailState } = useContext(AppStateContext)
    const { isExpanded, setIsExpanded } = useContext(PanelStyleContext)

    //keep detail menu expanded state in sync with panel expansion state
    useEffect(() => {
        setIsDetailMenuExpanded(isExpanded)
    }, [isExpanded, setIsDetailMenuExpanded])

    return (
        <PanelHeader extraClass="wellDetailPanelHeader">
            <div className="panelHeaderText">Details</div>
            <div className="panelButtons">
                <ExpandButton
                    name={'detail'}
                    isExpanded={isExpanded}
                    setIsExpanded={setIsExpanded}
                />
                <div
                    className="panelButton"
                    onClick={e => {
                        e.preventDefault()
                        updateDetailState('well', { visible: false })
                    }}
                >
                    <FaTimes />
                </div>
            </div>
        </PanelHeader>
    )
}
